import { queryAll, query, fromId } from '../utils/utils.js';
import instantsearch from 'instantsearch.js';

import algoliasearch from "algoliasearch";
import {
	configure,
	hits,
	pagination,
	searchBox,
	stats,
	currentRefinements,
	clearRefinements,
	refinementList,
	sortBy
} from 'instantsearch.js/es/widgets';
import { connectCurrentRefinements, connectClearRefinements } from 'instantsearch.js/es/connectors';
import { CardCollection } from "../components/card-collection";
import { searchScroll } from '../parts/search-scroll.js';
import { setAisSearchBoxAriaLabel } from './accessibility-helpers.js';

const NEWS_SEARCH_ARIA_LABEL = 'Search news and events';

export class NewsSearch {

	constructor() {
		// this.init();
	}


	init(){
		let doViewAll = false;

		const search = instantsearch({
			indexName: window.ALGOLIA_INDEX_PREFIX+'articles',
			searchClient: algoliasearch(
			  'LTCGWA12RB',
			  'fbbd5f8b545361104df6b21dfd244cc1'
			),
			routing: true,
			// searchFunction(helper) {
			// 	if (helper.state.query || doViewAll) {
			// 	  helper.search();
			// 	}
			// },
		});


		// ${item.attribute}
		const createDataAttribtues = refinement =>
			Object.keys(refinement)
		  		.map(key => `data-${key}="${refinement[key]}"`)
		  		.join(' ');

		const renderRefinementListItem = ({ item, createURL }) => `
				${item.refinements
					.map(refinement => `<div href="${createURL(refinement)}" class="bhs-link-button primary-btn light ">${refinement.value}  <button ${createDataAttribtues(refinement)}><span class="icon icon-exit"></span></button></div>`)
					.join('')}
			`;
			//</a>
		const renderCurrentRefinements = (renderOptions, isFirstRender) => {
			const { items, refine, createURL } = renderOptions;

			const container = document.querySelector('#refinement-list');

			container.innerHTML = `
			  <div class="refinements">
				${items.map(item => renderRefinementListItem({item, createURL})).join('')}
			  </div>
			`;

			let hasTypeFilter = false;
			items.forEach(item => {
				if(item.attribute === "type"){
					hasTypeFilter = true;
				}
			});
			if(hasTypeFilter){
				document.querySelector('.type-chooser-holder').classList.add("hide")
			}else{
				document.querySelector('.type-chooser-holder').classList.remove("hide")
			}




			[...container.querySelectorAll('button')].forEach(element => {
				element.addEventListener('click', event => {
				  const item = Object.keys(event.currentTarget.dataset).reduce(
					(acc, key) => ({
					  ...acc,
					  [key]: event.currentTarget.dataset[key],
					}),
					{}
				  );

				  console.log("clicked", item);
				  refine(item);
				});
			  });
		};

		const customCurrentRefinements = connectCurrentRefinements(
			renderCurrentRefinements
		);

		const renderClearRefinements = (renderOptions, isFirstRender) => {
			const { createURL, canRefine } = renderOptions;

			if (!isFirstRender && canRefine) {
				document.querySelector('#reset-filters').innerHTML = `
					<a href=${createURL()}>Reset Filters</a>
				`;
			}
			if(!canRefine){
				document.querySelector('#reset-filters').innerHTML = ``;
			}
		};

		const customClearRefinements = connectClearRefinements(
			renderClearRefinements
		);

		const renderClearAltRefinements = (renderOptions, isFirstRender) => {
			const { createURL, canRefine } = renderOptions;

			if (!isFirstRender && canRefine) {
				document.querySelector('#reset-type-filter').innerHTML = `
					<div class="item-type item ">
						<a href="${createURL()}" >
							<span>View All News</span>
						</a>
					</div>
				`;
			}
			if(!canRefine){
				document.querySelector('#reset-type-filter').innerHTML = ``;
			}
		};

		const customClearAltRefinements = connectClearRefinements(
			renderClearAltRefinements
		);



		search.addWidgets([
			searchBox({
			  container: "#searchbox",
			  placeholder: "Search"

			}),
			configure({
				hitsPerPage: 12,
			}),
			stats({
				container: '#stats',
				templates: {
					text(data, { html }) {
					  if (data.hasManyResults || data.hasOneResult){
						return html`<h4>Search Results (${data.nbHits})</h4>`;
					  }
					  return html`<h4>Search Results (0)</h4>`;
					}
				}
			}),
			stats({
				container: '#bottom-stats',
				templates: {
					text(data, { html }) {
					  if (data.hasManyResults || data.hasOneResult){
						let showing = data.page * data.hitsPerPage;
						if (data.page === 0) {
							if(data.nbHits < data.hitsPerPage){
								showing = data.nbHits;
							}else{
								showing = data.hitsPerPage;
							}
						}else if(data.page >= 1){
							showing = (data.page * data.hitsPerPage+1) + "-" + (data.page * data.hitsPerPage + data.hitsPerPage);
						}
						return html`<p>Showing ${showing}  of ${data.nbHits} results</p>`;
					  }
					  return html``;
					}
				}
			}),
			customCurrentRefinements({
				container: '#refinement-list',
			}),
			//big boxes
			refinementList({
				container: '#type-chooser',
				attribute: 'type',
				operator: 'or',
				sortBy: ['name:asc'],
				limit: 7,
				templates: {
					item(item, { html }) {
					  const { url, label, count, isRefined } = item;

					  return html`
					  	<div class="item-type item ${isRefined ? 'checked' : ''}">
							<a href="${url}" >
						  		<div class="icon icon-${label.toLowerCase()}"></div>
								<span>${label}</span>
							</a>
						</div>
					  `;
					},
				  },

			}),
			//drop down chooser
			refinementList({
				container: '#article-refine-category',
				attribute: 'type',
				operator: 'or',
				limit: 7,
				sortBy: ['name:asc'],
				templates: {
					item(item, { html }) {
					  const { url, label, count, isRefined } = item;

					  return html`
					  	<li class="checkbox item ${isRefined ? 'checked' : ''}">
							<a href="${url}" >
						  		<span>${label}</span>
							</a>
						</li>
					  `;
					},
				  },

			}),
			refinementList({
				container: '#article-refine-published-date',
				attribute: 'year',
				operator: 'or',
				limit: 20,
				templates: {
					item(item, { html }) {
					  const { url, label, count, isRefined } = item;

					  return html`
					  	<li class="checkbox item ${isRefined ? 'checked' : ''}">
							<a href="${url}" class=" ">
						  		<span>${label}</span>
							</a>
						</li>
					  `;
					},
				  },

			}),
			customClearRefinements({
				container: '#reset-filters',
			}),
			hits({
			  container: "#hits",
			  templates: {
				empty(results, { html }) {
					return html`<div class="no-results">No results found for <q>${results.query}</q></div>`;
				},
				item(hit, { html, components }) {
					// console.log(hit);
					let address1 = "";
					let address2 = "";
					try{
						let address_parts = hit.address.split("<br/>");
						address1 = address_parts[0];
						address2 = address_parts[1];
					}catch(e){
					}
					return html`
						<div class="search-result news-card card">
							<div class="image">
								<img src="${hit.image}" style="${hit.image != '' ? '' : 'display: none;'}" />
								<div class="tags">
									${hit.type ? html`<div class="tag">${hit.type}</div>` : ''}
								</div>
							</div>
							<div class="details">
								<div class="details-top">
									<div class="topline"></div>
									<div class="post-date">
										${hit.date}
									</div>
									<a href="${hit.url}" class="title">${hit.title}</a>
									<div class="event-date" style="${hit.event_date != '' ? '' : 'display: none;'}">
										${hit.event_date}
									</div>
								</div>
								<div class="details-bottom">
									<div class="address">
										<div class="address-details"  style="${hit.address != '' ? '' : 'display: none;'}">
											${address1}<br/>${address2}
										</div>
										<div class="news-cta card-cta">
											<a href="${hit.url}" class="bhs-link-button arrow-link icon-btn light"></a>
										</div>
									</div>
								</div>
							</div>
						</div>
					`;
					},
				},
			}),
			pagination({
				container: '#pagination',
				padding: 2,
				scrollTo: '#search-results',
			}),
		]);

		search.start();
		setAisSearchBoxAriaLabel('#searchbox', NEWS_SEARCH_ARIA_LABEL);

		searchScroll();

		search.on('render', () => {
			setAisSearchBoxAriaLabel('#searchbox', NEWS_SEARCH_ARIA_LABEL);
			window.addArrowLinks();
			new CardCollection();

			console.log("render by: ", search.helper);
			// console.log(search);
			// hide pagination if there is only one page
			if (search.helper?.lastResults?.nbPages == 1){
				document.querySelector('#pagination').classList.add("hide")
			}else{
				document.querySelector('#pagination').classList.remove("hide")
			}

			if (search.helper?.lastResults?.hits.length === 0){
				document.querySelector('.search-page').classList.add("no-results-found")
			}else{
				document.querySelector('.search-page').classList.remove("no-results-found")
			}


			if (query('.article-view-all') === null && query('#type-chooser .ais-RefinementList-list') !== null){
				//append view all to locations type list
				document.querySelector('#type-chooser .ais-RefinementList-list').insertAdjacentHTML('beforeend', `
				<li class="ais-RefinementList-item">
					<div>
						<div class="item-type item article-view-all">
							<a href="#" >
								<span>View All News</span>
							</a>
						</div>
					</div>
				</li>
				`);

				query('.article-view-all a').addEventListener('click', (event) => {
					event.preventDefault();
					console.log("here");
					doViewAll = true;
					search.setUiState((uiState) => ({
						...uiState,
						[window.ALGOLIA_INDEX_PREFIX+"articles"]: {
							...uiState[window.ALGOLIA_INDEX_PREFIX+"articles"],
							page: 1,
							refinementList: {
								...uiState[window.ALGOLIA_INDEX_PREFIX+"articles"].refinementList,
								type: [],
							}
						},
					}));
				});

			}

			// make search results clickable
			queryAll('.ais-Hits-list .ais-Hits-item .card').forEach((card) => {
				const button = card.querySelector('.bhs-link-button');
				card.querySelectorAll('a').forEach((a) => {

					if (!a.classList.contains('bhs-link-button')) {
						a.addEventListener('click', (e) => {
							e.stopPropagation();
						});
					}

				});

				if (button) {
					card.addEventListener('click', (e) => {
						button.click();
					});
					card.addEventListener('mouseover', (e) => {
						button.classList.add('hover');
					});
					card.addEventListener('mouseout', (e) => {
						button.classList.remove('hover');
					});
				}
			});

			//conditionally hide filters
			if(search.renderState[window.ALGOLIA_INDEX_PREFIX+"articles"]?.refinementList?.c_type?.items?.length < 1){
				document.querySelector('.dropdown-c-type').classList.add("hide")
			}else{
				document.querySelector('.dropdown-c-type').classList.remove("hide")
			}
			if(search.renderState[window.ALGOLIA_INDEX_PREFIX+"articles"]?.refinementList?.p_type?.items?.length < 1){
				document.querySelector('.dropdown-p-type').classList.add("hide")
			}else{
				document.querySelector('.dropdown-p-type').classList.remove("hide")
			}
		});
	}
}
